var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPasswordCursor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.6719V8.67188C21 8.14144 20.7893 7.63273 20.4142 7.25766C20.0391 6.88259 19.5304 6.67188 19 6.67188H5C4.46957 6.67188 3.96086 6.88259 3.58579 7.25766C3.21071 7.63273 3 8.14144 3 8.67188V14.6719C3 15.2023 3.21071 15.711 3.58579 16.0861C3.96086 16.4612 4.46957 16.6719 5 16.6719H12",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8792 17.5875C21.3732 17.8915 21.3422 18.6305 20.8342 18.6885L18.2672 18.9795L17.1162 21.2916C16.8882 21.7506 16.1832 21.5256 16.0662 20.9576L14.8112 14.8415C14.7122 14.3615 15.1442 14.0595 15.5612 14.3165L20.8792 17.5875V17.5875Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6829L8.01 11.6719M12 11.6829L12.01 11.6719L12 11.6829ZM16 11.6829L16.01 11.6719L16 11.6829Z",
    stroke: "#2F2F2F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPasswordCursor);
export default __webpack_public_path__ + "static/media/icon-password-cursor.af267346afbf299bf1d5cc05c2f63f9e.svg";
export { ForwardRef as ReactComponent };